/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Cc_All_TitleInputs */

const en_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark All As CC`)
};

const fr_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer tout comme CC`)
};

const de_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle als CC markieren`)
};

const it_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna tutto come CC`)
};

const ru_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметить все как CC`)
};

const es_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar todo como CC`)
};

const zh_cn2_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部标记为 CC`)
};

const ja_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてをCCとしてマーク`)
};

const hi_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी को CC के रूप में चिह्नित करें`)
};

const pt_pt2_iconik_publish_cc_all_title = /** @type {(inputs: Iconik_Publish_Cc_All_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar tudo como CC`)
};

/**
* | output |
* | --- |
* | "Mark All As CC" |
*
* @param {Iconik_Publish_Cc_All_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_cc_all_title = /** @type {((inputs?: Iconik_Publish_Cc_All_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Cc_All_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_cc_all_title(inputs)
	if (locale === "de") return de_iconik_publish_cc_all_title(inputs)
	if (locale === "it") return it_iconik_publish_cc_all_title(inputs)
	if (locale === "ru") return ru_iconik_publish_cc_all_title(inputs)
	if (locale === "es") return es_iconik_publish_cc_all_title(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_cc_all_title(inputs)
	if (locale === "ja") return ja_iconik_publish_cc_all_title(inputs)
	if (locale === "hi") return hi_iconik_publish_cc_all_title(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_cc_all_title(inputs)
	return en_iconik_publish_cc_all_title(inputs)
});